import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Wheat, Eye, EyeOff, KeyRound, ShieldCheck, Grape } from "lucide-react";
import { useApp } from "@/context/AppContext";

export default function OfficerLogin() {
  const { officerLogin, changePassword, user } = useApp();
  const navigate = useNavigate();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [showPw, setShowPw] = useState(false);
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);
  const [mustChange, setMustChange] = useState(false);
  // change pw fields
  const [np, setNp] = useState("");
  const [cp, setCp] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setError(""); setBusy(true);
    try {
      const u = await officerLogin(username.trim(), password);
      if (u.mustChangePassword) { setMustChange(true); }
      else navigate(u.role === "accountant" ? "/accountant" : "/officer/dashboard");
    } catch (err) { setError(err.message || "लॉगिन अयशस्वी."); }
    finally { setBusy(false); }
  };

  const doChange = async (e) => {
    e.preventDefault();
    setError("");
    if (np.length < 6) { setError("नवीन पासवर्ड किमान ٦ अक्षरांचा असावा."); return; }
    if (np !== cp) { setError("पासवर्ड जुळत नाही."); return; }
    setBusy(true);
    try {
      await changePassword(password, np);
      navigate("/officer/dashboard");
    } catch (err) { setError(err.message || "बदल अयशस्वी."); }
    finally { setBusy(false); }
  };

  const inputCls = "w-full rounded-lg border border-slate-200 bg-white px-4 py-3 text-[15px] outline-none focus:border-[#1b5e3f] focus:ring-2 focus:ring-[#1b5e3f]/20";

  return (
    <div className="min-h-screen bg-[#f6f2e6]">
      <div className="mx-auto grid max-w-5xl items-center gap-10 px-6 py-10 md:grid-cols-2 md:py-20">
        <div className="relative order-1 hidden overflow-hidden rounded-[1.75rem] bg-gradient-to-br from-[#1b5e3f] to-[#2d7a52] p-11 text-white md:block">
          <div className="pointer-events-none absolute -right-6 -top-6 opacity-15"><Wheat className="h-40 w-40" strokeWidth={1.2} /></div>
          <div className="pointer-events-none absolute bottom-4 right-6 opacity-15"><Grape className="h-24 w-24" strokeWidth={1.2} /></div>
          <span className="relative w-fit rounded-full bg-[#E0A106] px-4 py-1.5 text-[12px] font-bold text-[#1b3d2a] font-latin">OFFICER PORTAL</span>
          <h2 className="font-head relative mt-5 text-[34px] font-medium leading-tight">आपले सरकार सेवा केंद्र<br/><span className="text-[#F4CE6A]">अर्ज प्रक्रिया प्रणाली</span></h2>
          <p className="relative mt-4 text-[15px] text-[#d7ebda]">जिल्हाधिकारी / RDC / SDO / तहसीलदार यांसाठी कार्यक्षेत्रनिहाय अर्ज व्यवस्थापन.</p>
        </div>

        <div className="order-2 rounded-[1.75rem] border border-[#e6dcc4] bg-white p-8 shadow-[0_16px_50px_rgba(27,94,63,0.10)] sm:p-10">
          <div className="mb-4 flex items-center gap-2.5">
            <span className="flex h-10 w-10 items-center justify-center rounded-xl bg-[#1b5e3f] text-white">{mustChange ? <KeyRound className="h-5 w-5" /> : <ShieldCheck className="h-5 w-5" />}</span>
            <span className="font-latin text-[15px] font-bold text-[#1b5e3f]">ASSK Sangli</span>
          </div>
          {!mustChange ? (
            <>
              <h1 className="font-head text-[30px] font-medium text-[#1b5e3f]">Officer Login</h1>
              <p className="mt-1 text-[14px] text-[#6b7a60]">अधिकारी लॉगिन (वापरकर्तानाव व पासवर्ड)</p>
              <form onSubmit={submit} className="mt-6 space-y-4">
                <div>
                  <label className="mb-1.5 block text-[13px] font-bold tracking-wide text-slate-500">USERNAME</label>
                  <input value={username} onChange={(e) => setUsername(e.target.value)} placeholder="e.g. collector, sdo_miraj, teh_jat" className={inputCls} />
                </div>
                <div>
                  <label className="mb-1.5 block text-[13px] font-bold tracking-wide text-slate-500">PASSWORD</label>
                  <div className="relative">
                    <input type={showPw ? "text" : "password"} value={password} onChange={(e) => setPassword(e.target.value)} className={inputCls + " pr-11"} />
                    <button type="button" onClick={() => setShowPw(!showPw)} className="absolute right-3 top-1/2 -translate-y-1/2 text-slate-400">{showPw ? <EyeOff className="h-5 w-5" /> : <Eye className="h-5 w-5" />}</button>
                  </div>
                </div>
                {error && <p className="text-[13px] text-red-600">{error}</p>}
                <button type="submit" disabled={busy} className="w-full rounded-full bg-[#1b5e3f] py-3.5 text-[15px] font-semibold text-white transition-colors hover:bg-[#144d33] disabled:opacity-60">{busy ? "Signing in..." : "Sign In"}</button>
              </form>
            </>
          ) : (
            <>
              <h1 className="font-head text-[28px] font-medium text-[#1b5e3f]">पासवर्ड बदला</h1>
              <p className="mt-1 text-[14px] text-[#6b7a60]">प्रथम लॉगिनसाठी नवीन पासवर्ड निश्चित करा.</p>
              <form onSubmit={doChange} className="mt-6 space-y-4">
                <div>
                  <label className="mb-1.5 block text-[13px] font-bold tracking-wide text-slate-500">नवीन पासवर्ड</label>
                  <input type="password" value={np} onChange={(e) => setNp(e.target.value)} className={inputCls} />
                </div>
                <div>
                  <label className="mb-1.5 block text-[13px] font-bold tracking-wide text-slate-500">पासवर्ड पुन्हा लिहा</label>
                  <input type="password" value={cp} onChange={(e) => setCp(e.target.value)} className={inputCls} />
                </div>
                {error && <p className="text-[13px] text-red-600">{error}</p>}
                <button type="submit" disabled={busy} className="w-full rounded-full bg-[#1b5e3f] py-3.5 text-[15px] font-semibold text-white transition-colors hover:bg-[#144d33] disabled:opacity-60">{busy ? "..." : "पासवर्ड बदला व पुढे जा"}</button>
              </form>
            </>
          )}
          <button onClick={() => navigate("/login")} className="mt-5 block w-full text-center text-[13px] font-medium text-slate-500 hover:text-[#1b5e3f]">← अर्जदार लॉगिनकडे</button>
        </div>
      </div>
    </div>
  );
}
